export default [
    {
        path: 'relatorio-dispensacao-remedio-casa',
        component: () => import(/* webpackChunkName: 'farmacia-relatorio-dispensacao-remedio-casa' */ '@/views/farmacia/relatorio-dispensacao-remedio-casa/Index'),
        redirect: 'relatorio-dispensacao-remedio-casa/index',
        children: [
            {
                name: 'farmacia-relatorio-dispensacao-remedio-casa-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'farmacia-relatorio-dispensacao-remedio-casa' */ '@/views/farmacia/relatorio-dispensacao-remedio-casa/List.vue'),
            },
        ],
    },
]